import { Navigate, Route, Routes } from 'react-router'
import { RequireAuth, Shell } from './components'
import { useAuth } from './auth/useAuth'
import { homeFor } from './auth/roles'
import LoginPage from './pages/LoginPage'
import DashboardPage from './pages/DashboardPage'
import ApplicationsPage from './pages/ApplicationsPage'
import ApplicationDetailPage from './pages/ApplicationDetailPage'
import ResultsPage from './pages/ResultsPage'
import InvitesPage from './pages/InvitesPage'
import CampaignsPage from './pages/CampaignsPage'
import CampaignDetailPage from './pages/CampaignDetailPage'
import PlansPage from './pages/PlansPage'
import ContentPage from './pages/ContentPage'
import BankPage from './pages/BankPage'
import BanksPage from './pages/BanksPage'
import ComposePage from './pages/ComposePage'
import KeyEditorPage from './pages/KeyEditorPage'
import StaffPage from './pages/StaffPage'
import AccountPage from './pages/AccountPage'
import ProgramsPage from './pages/ProgramsPage'
import CareersPage from './pages/CareersPage'
import SettingsPage from './pages/SettingsPage'
import InstitutionsPage from './pages/InstitutionsPage'
import SsoCompletePage from './pages/SsoCompletePage'

function Home() {
  const { roles } = useAuth()
  return <Navigate to={homeFor(roles)} replace />
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/sso-complete" element={<SsoCompletePage />} />
      <Route element={<RequireAuth />}>
        <Route element={<Shell />}>
          <Route index element={<Home />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/applications" element={<ApplicationsPage />} />
          <Route path="/applications/:id" element={<ApplicationDetailPage />} />
          <Route path="/results" element={<ResultsPage />} />
          <Route path="/campaigns" element={<CampaignsPage />} />
          <Route path="/campaigns/:id" element={<CampaignDetailPage />} />
          <Route path="/invites" element={<InvitesPage />} />
          <Route path="/plans" element={<PlansPage />} />
          <Route path="/content" element={<ContentPage />} />
          <Route path="/content/versions/:versionId/key" element={<KeyEditorPage />} />
          <Route path="/content/versions/:versionId/compose" element={<ComposePage />} />
          <Route path="/banks" element={<BanksPage />} />
          <Route path="/banks/:bankId" element={<BankPage />} />
          <Route path="/programs" element={<ProgramsPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/staff" element={<StaffPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/institutions" element={<InstitutionsPage />} />
          <Route path="/account" element={<AccountPage />} />
        </Route>
      </Route>
    </Routes>
  )
}
